const indexComponent = require('./components/Account');

const indexRoute = {
  component: indexComponent,
};

module.exports = {
  path: 'account',
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/MainApp'));
    });
  },
  getIndexRoute(partialNextState, cb) {
    require.ensure([], () => {
      cb(null, indexRoute);
    });
  },
};



// WEBPACK FOOTER //
// ./routes/account/index.js